import { formatObjToParamStr, getUrlParams, isAlipayMiniProgramBrowser } from './common-helper';
import { logAddressURL } from '../config';

const aliminiProgramHelper = {
  _jssdkUrl: 'https://appx/web-view.min.js',

  _init() {
    if (!this.isMiniProgramMode()) {
      return Promise.reject(new Error('not in ali'));
    }

    if (this.inited) {
      return Promise.resolve(window.my);
    }

    return new Promise((resolve, _reject) => {
      let script = document.createElement('script');

      // other version js loaded;
      delete window.my;

      script.onload = () => {
        this.inited = true;
        resolve(window.my);
      };

      script.src = this._jssdkUrl;
      document.body.appendChild(script);
      script = null;
    });
  },

  isMiniProgramMode() {
    return isAlipayMiniProgramBrowser();
  },

  call(method, ...args) {
    this._init()
      .then(my => {
        if (!my || !my[method]) {
          throw new Error('ali jssdk unload');
        }

        const fn = my[method];
        if (!fn) {
          throw new Error(`miniProgram do not contains the method of ${method}`);
        }
        return fn.apply(my, args);
      })
      .catch(e => {
        // alert(e.message);
        console.warn(e.message);
      });
  },

  navigateTo(url, params) {
    this.route('navigateTo', url, params);
  },

  // redirectTo在小程序中不会保留页面栈 不能用my.navigateBack返回  但navigateTo可以
  redirectTo(url, params) {
    this.route('redirectTo', url, params);
  },

  route(method, url, params) {
    const nextUrl = `${url}?${formatObjToParamStr(params)}`;

    this.call(method, { url: nextUrl });
  },

  postMessage() {
    this.call('postMessage');
  },

  onMessage(cb) {
    this._init().then(my => {
      my.onMessage = cb;
    });
  },
};

export default aliminiProgramHelper;

const interceptor = {
  handlers: {},

  add(url, handler) {
    const urls = [].concat(url);

    urls.forEach(item => {
      this.handlers[item] = handler;
    });
  },

  exec(url, params, ...rest) {
    const fixedUrl = url
      .replace(/^https?:\/\//, '')
      .split('/')
      .slice(1)
      .join('/');

    const handler = this.handlers[`/${fixedUrl}`];
    if (!handler || !aliminiProgramHelper.isMiniProgramMode()) {
      return false;
    }

    handler(url, params, ...rest);

    return true;
  },
};

// 支付页
// interceptor.add('/shop/payDetail', (url, params) => {
//   aliminiProgramHelper.navigateTo('/pages/pay/pay', params);
// });

// 登录页
interceptor.add(['/user/notLogin', '/user-login.html'], (url, params, method = 'navigateTo') => {
  aliminiProgramHelper[method]('/pages/login/login', params);
});

const aliPageHelper = {
  navigateTo(url, params) {
    // TODO: 暂时屏蔽掉拦截器。所有都还是走h5
    if (interceptor.exec(url, params) === true) {
      return;
    }
    console.log('--------navigateTo', url);
    location.href = `${url}?${formatObjToParamStr(params)}`;
  },

  redirectWhenInit() {
    const params = getUrlParams();

    return interceptor.exec(location.pathname, params, 'redirectTo');
  },

  navigateToLoginPage(params) {
    try {
      const tableId = sessionStorage.getItem('tableId');
      let tableQuery = '';
      if (tableId) {
        tableQuery = `&tableId=${tableId}`;
      }
      const finalParams = {
        returnUrl: encodeURIComponent(`${location.href}${tableQuery}`),
        ...params,
      };
      this.navigateTo(logAddressURL, finalParams);
    } catch (ex) {
      console.log('--------navigateToLoginPage ex', ex);
    }
  },
};

export { aliPageHelper };



// WEBPACK FOOTER //
// ./src/helper/ali-miniprogram-helper.js